<template>
<row style="margin-top: 20px;">
<loading :active.sync="isLoading"
    :can-cancel="true"
    color="#5bad2b"
    :is-full-page="fullPage"></loading>
      <div class="col-md-12">
        <div v-show="showsubscribeform" class="modal fade in" id="modal-default" style="display: block; padding-right: 17px;">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body">
                <div style="text-align:center;margin-top: 30px;">{{subscribe_content}}</div>
              </div>
              <div class="modal-footer" style="border-top-color: #ffffff;">
                <button type="button" @click="close()"  class="btn btn-default"> Close</button>
                <!-- <button type="button" @click="uninterestRequest(profileid)"  class="btn btn-success"> Yes</button> -->
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
          <!-- Custom Tabs -->
          <div class="nav-tabs-custom" style="margin-top: 20px;margin-bottom: 25px;">
            <ul class="nav nav-tabs">
              <li v-on:click="navigation('Post')"><a href="#tab_1" data-toggle="tab">Post</a></li>
              <li v-on:click="navigation('To-be-Scheduled')"><a href="#tab_2" data-toggle="tab">To-be Scheduled</a></li>
              <li v-on:click="navigation('Scheduled')"><a href="#tab_3" data-toggle="tab">Scheduled</a></li>
              <li class="active" v-on:click="navigation('Result')"><a href="#tab_4" data-toggle="tab">Result</a></li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane active" id="tab_1">
              <div class="col-md-6 remove-pad">
                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h3 class="box-title">Result</h3>
                  </div>
                  <div class="box-header with-border">
                    <input @keyup="getDatas()" v-model="postsearch" type="text" class="form-control pull-left search-text" placeholder="Search" style="width:50%;height: 20% !important;">
                    <div style="width:50%;" class="pull-right">
                      <div class="form-group">
                        <div class="form-select pull-right" style="width: 50%;">
                          <select class="form-control input-sm" v-model="postsort" @change="getDatas()">
                            <option value="7">Last 7 days</option>
                            <option value="30">Last 30 days</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                      </div>
                      <span class="pull-right ml-1" style="margin-top: -5px;">Sort by</span>
                    </div>
                  </div>
                  <!-- /.box-header -->
                  <div class="box-body scroll-manual">
                    <div style="text-align:center; margin-top:30%" v-if="datas.length < 1">
                      <img src="../../assets/img/result_empty.svg" alt="Product Image" style="width: 150px;">
                      <br>
                      <!-- <span style="font-size: 12px;">No data found</span> -->
                    </div>
                    <ul class="products-list product-list-in-box">
                        <div style="margin-top:30px;text-align:center;color:black;" v-if="datas.length < 1"> No data found</div>

                       <li class="item" v-for="x in datas" :key="x" @click="getReleventProfile(x._id, x)" v-bind:class="{'active': selectpost === x._id}">
                          <div class="row">
                         <div class="col-md-5 p-1">
                           <div class="product-img">
                            <img v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`" class="img-circle">
                            <img v-if="x.profile_picture =='' || x.profile_picture ==null" src="../../assets/img/org-default.png" class="img-circle">
                            <img v-if="x.post_expired =='true'" src="../../assets/img/expired.png" class="img-circle exp-img mt-2" style="margin-top: 21px !important;width: 13px !important;margin-left:-9px;height: 13px !important;">
                          </div>
                          <div class="product-info">
                            <a href="javascript:void(0)" class="product-title">{{x.job_tittle}} <img v-if="x.notification_count > 0" src="../../assets/img/green_dot.svg" class="img-circle">
                            </a>
                            <span class="product-description" :title="x.post_unique_id"><span class="skill-lable">{{x.post_unique_id}}</span></span>
                          </div>
                         </div>
                         <div class="col-md-7 p-1">
                            <div class="pull-right showdate">
                              <span class="ml-1">Posted on : {{x.created_at | formatDate}}</span>
                              <!-- <span>Validity : {{x.post_validity | formatDate}}</span> -->
                            </div>
                          </div>
                          <div class="col-md-7 showdate1">
                            <span class="pull-right" v-if="x.isclient =='yes'">Created by : {{x.created_by_name}}</span>
                          </div>
                         </div>
                         <div class="row">
                          <div class="col-md-5 p-1">
                            <div class="ml-5 mt-2">
                            <span class="product-description" :title="x.primaryskillnames"><span class="skill-lable">Skills</span>
                              {{x.primaryskillnames}}
                            </span>
                          </div>
                          </div>
                          <div class="col-md-7 p-1">
                            <div class="tc">
                              <div class="btn-group">
                              <button type="button" class="btn bg-full btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Completed</button>
                              <button type="button" class="btn btn-default btn-sm b-c ml-1">{{x.completedcount}}</button>
                            </div>
                            <div class="btn-group">
                              <button type="button" class="btn bg-full btn-sm"><i class="fa fa-calendar" aria-hidden="true"></i> Scheduled</button>
                              <button type="button" class="btn btn-default btn-sm b-c ml-1">{{x.schedulecount}}</button>
                            </div>
                            </div>
                          </div>
                         </div>
                        </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-6 remove-pad">
                <div class="box box-primary">
                  <div class="box-header with-border" v-if="datas.length > 0 && selectdatas">
                    <div class="direct-chat-msg">
                      <div class="clearfix">
                        <span class="direct-chat-name pull-left" v-if="selectdatas.job_tittle">{{selectdatas.job_tittle}}</span>
                        <!-- <span class="direct-chat-timestamp pull-right" v-if="selectdatas.created_at">Posted on : {{selectdatas.created_at | formatDate}}</span> -->
                      </div>
                    </div>
                    <div class="direct-chat-msg">
                      <span class="direct-chat-timestamp pull-left">{{selectdatas.post_unique_id}} <span class="ml-20" v-if="selectdatas.post_expired =='true'"><img src="../../assets/img/expired.png" class="img-circle exp-img" style="width: 13px !important;margin-top:2px;height: 13px !important;"> <span class="expired">Expired</span></span></span>
                    </div>
                    <div class="direct-chat-msg">
                      <span class="direct-chat-timestamp pull-left" v-if="selectdatas.primaryskillnames">Skills <span style="color:black"> {{selectdatas.primaryskillnames}}</span></span>
                      <span class="direct-chat-timestamp pull-right" v-if="selectdatas.post_validity">Validity : {{selectdatas.post_validity | formatDate}}</span>
                    </div>
                  </div>
                  <div class="box box-primary" v-if="datas.length > 0 && selectdatas">
                    <div class="box-header with-border">
                      <span class="direct-chat-name">Results</span>
                      <div class="box-tools pull-right">
                        <span>Sort by: </span>
                        <button type="button" class="btn btn-box-tool" data-widget="collapse">Timings <i class="fa fa-long-arrow-up" aria-hidden="true"></i><i class="fa fa-long-arrow-down" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn btn-box-tool" data-widget="remove">Price <i class="fa fa-long-arrow-up" aria-hidden="true"></i><i class="fa fa-long-arrow-down" aria-hidden="true"></i></button>
                      </div>
                    </div>
                  </div>
                  <!-- /.box-header -->
                  <div style="margin-top:50%;text-align:center" v-if="releventprofileslength < 1">
                       <img src="../../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                  </div>
                  <CardView :result="true" :data="releventprofiles" :showRole="showRole" :selectpost="selectpost" :currentTimezone="currentTimezone"></CardView>
                  <!-- <div class="direct-chat-messages" v-for="x in releventprofiles" :key="x">
                    <div class="direct-chat-msg" style="cursor:pointer;">
                      <img @click="showModal(x._id)" v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`" class="direct-chat-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == null" src="../../assets/img/default.png" class="direct-chat-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Female'" src="../../assets/img/female_default.png" class="direct-chat-img">
                              <img @click="showModal(x._id)" v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Male'" src="../../assets/img/male_default.png" class="direct-chat-img">
                      <div class="direct-chat-info clearfix">
                        <span class="direct-chat-name pull-left ml8 name" @click="showModal(x.user_id)">{{x.first_name}} {{x.last_name}}<br>
                          <span style="color:#999;font-weight: 400;">Applied on : {{x.interviewer_interest_date | formatDatetimea }}</span>
                        </span>
                        <span @click="showShedule(x._id,x.user_id)" class="direct-chat-timestamp pull-right" style="width:25%">Rating  <star-rating class="pull-right" style="width:60%" :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="15" :rating="x.interviewer_rating" read-only="true"></star-rating></span>
                        <button v-if="!showRole" @click="showShedule(x._id,x.user_id)" class="btn btn-default btn-xs btns pull-left ml8"><i class="uil uil-rupee-sign"></i>{{x.interview_cost}} / Interview</button>
                      </div>
                      <div class="direct-chat-info clearfix" @click="showShedule(x._id,x.user_id)">
                        <span class="direct-chat-timestamp pull-left">Skillset : <span style="color:black">{{x.userskillnames}}</span></span>

                        <span class="direct-chat-timestamp pull-right" style="width:27%;color: #60AB2F;"><i class="fa fa-clock-o" aria-hidden="true"></i> {{getTime(x.startdatetime_utc)}} - {{getTime(x.enddatetime_utc)}} {{currentTimezone}}</span>
                        <span class="direct-chat-timestamp pull-right" style="width:20%;color: #60AB2F;"><i class="uil uil-calender" aria-hidden="true"></i> {{getDate(x.startdatetime_utc)}}</span>
                      </div>
                      <div class="direct-chat-info clearfix">
                        <div>
                          <span class="direct-chat-timestamp pull-left">Candidate Name : <span style="color:black"> {{x.candidate_name}} {{x.candidate_lastname}}</span></span>
                          <button type="button" @click="showShedule(x._id,x.user_id)" class="btn btn-default btn-flat btn-sm b-c result pull-right">View Result    <i class="fa fa-caret-right" aria-hidden="true"></i></button>
                          <span v-if="x.feedback_status =='Completed'" class="result-status-p pull-right">Completed</span>
                          <span v-if="x.feedback_status =='Pending'" class="result-status-c pull-right">Pending</span>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
              </div>
              <!-- /.tab-pane -->
            </div>
            <!-- /.tab-content -->
          </div>
          <!-- nav-tabs-custom -->
          <profile-modal v-model="modalOpen" v-if="modalOpen"></profile-modal>
          <add-shedule v-model="sheduleOpen" v-if="sheduleOpen"></add-shedule>
        </div>
        <!-- rating popup startdate -->
          <div class="modal fade in" id="modal-default" style="display: block;" v-show="showratingform">
            <div class="modal-dialog" style="margin-top:15px">
              <div class="modal-content" style="width: 701px;">
                <div class="modal-body" style="padding:0px">
                  <div class="row">
                    <div class="col-md-12 " style="padding:0px">
                      <div class="col-md-6" style="background-color: #F5F5F5">
                          <img src="../../assets/img/rating_img.svg" alt="Product Image" class="rating-img">
                      </div>
                      <div class="col-md-6">
                        <h5>Rate our Interviewer</h5>
                        <hr>
                          <div class="rating-show">
                              <star-rating :show-rating="false" @current-rating="setCurrentRating($event, anotherParam)" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20"></star-rating>

                          </div>
                          <b-form-textarea style="margin-top: 86px;" v-model="rating_comments" class="textarea" rows="2" placeholder="Enter comments *"></b-form-textarea>
                          <div class="form-submit" style="text-align: center;">
                            <p style="color:red" v-if="showrating_error">Please choose a star *</p>
                            <input type="submit" @click="ratingsubmit()" style="cursor:pointer" value="Submit" class="submit" name="submit" id="submit" />
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
          </div>
          <!-- rating popup end -->
    </row>
</template>
<script>

import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import router from '../../router/index'
import AddShedule from '../Feature/result_popup'
import StarRating from 'vue-star-rating'
import ProfileModal from '../Feature/profileDetails'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import momentsone from 'moment-timezone'
import moment from 'moment'
import CardView from '../Feature/cardView'
export default {
  name: 'Result',
  data () {
    return {
      viewid: [],
      job_title: '',
      job_skills: '',
      job_validity: '',
      job_postedon: '',
      datas: [],
      releventprofiles: [],
      mainurl: '',
      sid: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      base_urls: BaseURL,
      postsearch: '',
      postsort: 7,
      datassShow: 15,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      selectpost: '',
      sheduleOpen: false,
      modalOpen: false,
      showratingform: false,
      showrating_error: false,
      isLoading: true,
      fullPage: true,
      postdatas: [],
      showrole: false,
      profileid: '',
      actiontype: '',
      timezone: momentsone.tz.guess(),
      rating_comments: '',
      rating_count: '',
      selectdata: JSON.parse(localStorage.getItem('postId')),
      selectdatas: [],
      releventprofileslength: 0,
      showsubscribeform: false,
      timezoneApp: '',
      currentTimeZone: momentsone.tz.guess(),
      subscribe_content: 'Screenit limits video access to prime customers only. Kindly subscribe to view the recorded interview session.'
    }
  },
  components: {
    StarRating, AddShedule, ProfileModal, Loading, CardView
  },
  created () {
    this.tabOne = true
    this.getDatas()
    this.$root.$emit('navigate', 'Result')
    var time = new Date()
    var timeZoneOffset = time.getTimezoneOffset()
    this.timezoneApp = moment.tz.zone(this.currentTimeZone).abbr(timeZoneOffset)
    this.currentTimezone = this.timezoneApp
    var email = this.userInfo.user_email
    var sp = email.split('@')
    if (sp[1] === 'acsicorp.com') {
      this.showRole = true
    }
  },
  mounted () {
    this.$root.$on('message_from_tobe', (arg) => {
      console.log(arg)
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      this.getDatas()
    })
    this.$root.$on('message_get_rating', (arg) => {
      console.log(arg)
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      this.sid = arg
      this.showgetrating()
    })
    this.$root.$on('message_get_subscribe', (arg) => {
      console.log(arg)
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      this.sid = arg
      this.showgetsubscribe()
    })
    this.$root.$on('message_get_subscribe1', (arg) => {
      console.log(arg)
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      this.sid = arg
      this.subscribe_content = 'The post creator does not subscribe to view the recorded interview session.'
      this.showgetsubscribe()
    })
  },
  methods: {
    getDate (date) {
      const Start = momentsone.utc(date).tz(this.timezone).format('DD MMM YYYY')
      return Start
    },
    getTime (date) {
      const Start = momentsone.utc(date).tz(this.timezone).format('hh:mm a')
      return Start
    },
    updateinterestcount (type, intid) {
      console.log('checking')
      const id = this.userInfo._id
      axios.get(BaseURL + '/dashboard/update_notification/web/' + id + '/' + this.selectpost + '/' + type, this.config).then(response => {
        this.reloaddata()
      }).catch(e => {
      })
    },
    reloaddata () {
      this.config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      if (this.postsearch) {
        this.mainurl = '/dashboard/get_schedule_post_list_result/web/' + this.postsearch + '/' + this.postsort + '/' + this.userInfo._id
      } else {
        this.mainurl = '/dashboard/get_schedule_post_list_result/web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
      }
      axios.get(`${this.base_urls}${this.mainurl}`, this.config).then(response => {
        this.datas = response.data.postDetails
      }).catch(e => {
        console.log(e)
      })
    },
    showgetrating () {
      this.showratingform = true
    },
    showgetsubscribe () {
      this.showsubscribeform = true
    },
    close () {
      this.showsubscribeform = false
    },
    setCurrentRating (e) {
      console.log(e)
      this.rating_count = e
      this.showrating_error = false
    },
    changecomments () {
      this.showrating_error = false
    },
    ratingsubmit () {
      console.log(this.rating_count)
      if (this.rating_count === undefined || this.rating_count === '' || this.rating_count === null) {
        this.showrating_error = true
        return false
      } else {
        this.showrating_error = false
      }
      this.postdatas = {
        schedule_id: this.sid,
        interviewer_rating: this.rating_count,
        interviewer_rating_comments: this.rating_comments
      }
      const mainurl = '/dashboard/add_rating_to_interviewer'
      axios.post(`${this.base_urls}${mainurl}`, { formData: this.postdatas }, this.config).then(response => {
        this.showratingform = false
        this.rating_comments = ''
      }).catch(e => {
        console.log(e)
      })
    },
    getReleventProfile (id, val) {
      if (val !== 'no') {
        this.selectdatas = val
      }
      this.selectpost = id
      const mainurl = '/dashboard/get_schedule_user_list_result/web/' + id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.releventprofiles = response.data.postDetails
        this.releventprofileslength = this.releventprofiles.length
        this.updateinterestcount('feedback', '1')
      }).catch(e => {
        console.log(e)
      })
    },
    showShedule (id, userid) {
      this.viewid = userid
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      localStorage.setItem('sid', JSON.stringify(id))
      this.sheduleOpen = true
    },
    showModal (id) {
      this.viewid = id
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.selectpost))
      this.modalOpen = true
    },
    getDatas () {
      console.log('checking')
      if (this.postsearch) {
        this.mainurl = '/dashboard/get_schedule_post_list_result/web/' + this.postsearch + '/' + this.postsort + '/' + this.userInfo._id
      } else {
        this.mainurl = '/dashboard/get_schedule_post_list_result/web/' + "''" + '/' + this.postsort + '/' + this.userInfo._id
      }
      axios.get(`${this.base_urls}${this.mainurl}`, this.config).then(response => {
        this.datas = response.data.postDetails
        this.isLoading = false
        console.log(this.selectdata)
        if (this.selectdata !== 'no' && this.selectdata !== '' && this.selectdata !== null) {
          if (this.selectdata.post_id) {
            this.selectpost = this.selectdata.post_id
          } else {
            this.selectpost = this.selectdata._id
          }
        } else {
          if (this.datas.length > 0) {
            this.selectpost = this.datas[0]._id
            this.selectdata = this.datas[0]
          }
        }
        if (!this.datas.some(data => data._id === this.selectpost)) {
          this.isLoading = false
          this.selectpost = this.datas[0]._id
          this.selectdata = this.datas[0]
        }
        this.getReleventProfile(this.selectpost, this.selectdata)
        this.getpostdata()
      }).catch(e => {
        console.log(e)
        // router.push({ name: 'Login' })
      })
    },
    getpostdata () {
      const mainurl = '/dashboard/get_post_details/ios/' + this.selectpost + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.selectdatas = response.data.interviewerList[0]
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs) {
      router.push({ name: tabs })
    }
  }
}
</script>

<style scoped>
.f11 {
  font-size: 11px;
}
.tabs.is-centered.is-fullwidth {
  margin-bottom: 0px;
}
ul {
    margin-bottom: 0;
    padding-bottom: 0;
}
.box___border {
  border-style: solid;
  border-width: 0px 0px 0px 0px;
  border-bottom-color: #98a2ac;
  border-right-color: #98a2ac;
  border-left-color: #98a2ac;
}
.navigation-tabs.full-pills .tabs ul {
  padding-bottom: 0px;
  border-bottom: 0px solid #fff !important;
}

.is-active {
    background-color: #fff;
}

.tabs ul li {
    text-align: center;
    padding: 9px;
    background-color: #f9f9f9;
    cursor: pointer;
}
li.green-tab.is-active {
  border-style: solid;
  border-width: 4px 0px 0px 0px;
  border-top-color: rgb(91, 173, 43);
  border-right-color: #98a2ac;
  border-left-color: #98a2ac;
}
.posttab li.green-tab.is-active {
  border-style: solid;
  border-width: 4px 0px 0px 0px;
  border-top-color: rgb(91, 173, 43);
  background: #5bad2b;
  color: #fff;
}
.flex-card .card-body.is-small {
  /* padding-right: 15px !important;
  padding-bottom: 15px !important;
  padding-left: 15px !important; */
  padding: 10px 0px;
}
.ul-padding {
  padding-top: 0px !important;
}

ol,
ul,
dl {
  margin-bottom: 0px;
}
li {
  border-bottom: 1px solid #ededed;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #fff;
}
.user-list li:hover {
  cursor: pointer;
  background-color: #f9f9f9;
  cursor: pointer;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #5BAD2B;
}
.user-list li.is-active {
  cursor: pointer;
  background-color: #f9f9f9;
  cursor: pointer;
  border-style: solid;
  border-width: 0 0 0 4px;
  border-color: #5BAD2B;
}
.pading-top-only {
  padding: 0px 18px 15px;
}
.flex-card.light-bordered.raised {
    box-shadow: none;
}
.flex-card.is-active .name {
    color: #23282c !important;
}
.view-all-btn {
  border: 1px solid #5BAD2B;
  padding: 9px;
}
.card-body li {
  border-bottom: 1px solid #ededed;
}
.view-all-btn {
    border: 1px solid #bfc1c7e8;
    padding: 5px;
}

.posttab ul li {
  padding: 4px;
}
.unintrest {
    border-color: #c8ced3;
    background-color: #ededed73 !important;
    color: #23282c !important;
}
.unintrest :hover {
  border-color: #5BAD2B;
  background-color: #5BAD2B;
  color: #fff;
}
input[type=radio]:checked + label {
  color: #f00;
  font-style: normal;
}

.posttab .tabs ul li[data-v-6e981812] {
    text-align: center;
    padding: 9px;
    background-color: #f9f9f9;
    cursor: pointer;
    border: 1px solid #ccc !important;
}
option:hover{

    background-color:white;
    color: black;

}
.img-avatar {
  width: 100%;
  height: 100%;
}
.profilename:hover {
  color:#5BAD2B;
}
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      max-height: calc(100vh - 40px);
      width: 501px;
  }
}

.selectdate {
  border: 1px solid #ccc;
}
.selectdate .txt {
  font-size: 12px;
  color: #73818f !important;
}
.post_interview-type {
  /* background-color: #5BAD2B !important;
  color: #fff !important;
  border: 1px solid #5BAD2B !important; */
  background-color: #fff !important;
  color: #656565 !important;
  border: 1px solid #c8ced3 !important;
}
.interview-type {
  height: 38px;
  text-align: center;
  padding: 0px !important;
  font-weight: 200;
  font-size: 12px;
  width: 47% !important;
  margin: 0px 15px;
  cursor: pointer;
}

.donate-now {
  list-style-type: none;
  margin: 25px 0 0 0;
  padding: 0;
}

.donate-now li {
  float: left;
  margin: 0 5px 0 0;
  width: 112px;
  height: 52px;
  position: relative;
}

.donate-now label,
.donate-now input {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.donate-now input[type="radio"] {
  opacity: 0.01;
  z-index: 100;
}

.donate-now input[type="radio"]:checked+label,
.Checked+label {
  background: #5bad2b;
  color:#fff;
}

.donate-now label {
  padding: 5px;
  border: 1px solid #CCC;
  cursor: pointer;
  z-index: 90;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.donate-now label:hover {
  background: #DDD;
}
.card-body li {
    border-bottom: 0px;
}
.user-list li {
  border-bottom: 1px solid #ccc;
}
.remove-pad {
  padding-right: 0px;
  padding-left: 0px;
  border-right: 1px solid #d8d7d794;
  height: auto;
  min-height: 700px;
}
.nav-tabs-custom>.tab-content {
  padding: 0px;
  margin-top: 10px;
}
a {
    color: #333;
}
.tab-content {
  background-color: white;
  height: 100% !important;
  min-height: 700px;
  display: flow-root;
}
.box-header.with-border {
    border: 1px solid #d8d7d794;
}
.filterdrop {
  height: 29px;
  font-size: 12px !important;
}
.direct-chat-msg {
    margin-bottom: 0px;
}
.btns {
  background-color: white;
  color: #5bad2b;
}
.post li a {
  line-height: 15% !important;
}
.post.nav-tabs li {
  width: auto;
}
.post li {
  border-width: 0 0 0 0px !important;
}
.nav-tabs.post>li>a:hover {
    border-color: #f5f5f5 #f5f5f5 #f5f5f5 !important;
}
.posttab ul {
  background-color: #f5f5f5 !important;
}
.post li.active a{
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.ml8 {
  margin-left: 8px !important;
}
.direct-chat-messages {
  height: auto !important;
  border-bottom: 1px solid #cccccc73;
}
.direct-chat-messages:hover {
  border-left: 3px solid #5bad2b;
  background-color: #cccccc24;
}
.showdate {
  color: rgb(153, 153, 153);
  font-weight: 400;
  font-size: 12px;
  margin-right: 5px;
}
.product-info {
  margin-top: 5px;
}
.btn-group {
  margin-right: 5px;
}
.btn-group {
  margin-right: 5px;
}
select.input-sm {
    height: 30px;
    line-height: 17px !important;
    border: 1px solid #88888840;
}
.modal-header {
    padding: 8px;
}
hr {
  margin-top: auto;
  margin-bottom: auto;
}
.box {
  margin-bottom: 0px !important;
}
.rescheduled-l {
  color: rgb(255, 255, 255);
  background-color: rgb(31, 141, 2);
  padding: 1px 8px 0px;
}
.requested-l {
  color: #1F8D02;
  background-color: #F8F8F8;
  padding: 1px 8px 0px;
}
.requested-pending-l {
  color:#42D21E;
  background-color: #F8F8F8;
  padding: 1px 8px 0px;
}
.row {
  margin-right: 0px;
  margin-left: 0px;
}
.bg-status {
  padding: 4px;
  background-color: #f5f5f5;
}

.result {
  border: 1px solid #5bad2b !important;
  color: #5bad2b !important;
  margin-left: 6px;
}
.result-status-p {
  background-color: #f5f5f5;
  color: #60AB2F;
  padding: 3px 7px 4px 6px;
  margin-top: 4px;
}
.result-status-c {
  background-color: red;
  color: #fff;
  padding: 3px 7px 4px 6px;
  margin-top: 4px;
}
.rating-img {
  width: 339px;
  max-width: 300px;
  margin-top: 40px;
  margin-bottom: 40px;
}
.rating-show {
  margin-top: 40px;
  width: 50%;
  position: absolute;
  left: 27%;
}
.box {
  box-shadow: 0 1px 1px rgb(255, 255, 255) !important;
}
</style>
